import { Inject } from "@angular/core"
import { TranslocoService } from "@jsverse/transloco"
import { TranslocoCurrencyPipe, TranslocoDatePipe, TranslocoDecimalPipe, TranslocoPercentPipe } from "@jsverse/transloco-locale"
import { DurationPipe } from "../pipes/duration.pipe"
import { Column } from "../interfaces/table"

export function getPathKey(obj: any, path: any, defValue?: any) {
    if (!path) return defValue
    const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g)
    const result = pathArray.reduce(
        (prevObj: any, key: any) => prevObj && prevObj[key],
        obj
    )
    return result === undefined || result === null ? defValue : result
}

export function findBy(array: any[], key: string, value: any) {
    return array.find(item => item[key] === value)
}